<template>
	<!-- TOP BAR -->
	<section class="hidden md:flex bg-white dark:bg-gray-800 p-6 rounded-lg shadow space-y-4 top-0 sticky">
		<button
		  class="ms-auto"
		  @click="userLogout"
		>
		  Salir
		</button>
	</section>
	Holis Ordenes
</template>